import {Modal} from '@cvent/carina/components/Modal';
import {DismissButton} from '@cvent/carina/components/ScrollViewWithBars';
import {getFeatureDetails} from '../feature-comparison/feature-table-helpers';

type FeatureDetailsModalProps = {
  featureKey: string | null;
  handleClose: () => void;
};

const FeatureDetailsModal = ({
  featureKey,
  handleClose,
}: FeatureDetailsModalProps) => {
  if (!featureKey) {
    return null;
  }

  const details = getFeatureDetails(featureKey);

  if (!details) {
    return null;
  }

  return (
    <Modal
      isOpen
      format="sm"
      onDismiss={handleClose}
      aria-labelledby="feature-details-title"
      testID="feature-details-modal"
    >
      <div className="flex flex-col box-border w-[420px] max-h-[600px] p-6 pt-4">
        <div className="mb-4 flex items-start justify-between">
          <h2
            id="feature-details-title"
            className="text-[length:var(--carina-font-size-display-2xs)] font-[var(--carina-font-weight-display)] leading-[var(--carina-line-height-display-2xs)] pt-1"
          >
            {details.title}
          </h2>
          <DismissButton aria-label="Dismiss" onClick={handleClose} />
        </div>
        <div className="space-y-4 text-[length:var(--carina-font-size-sm)] leading-[var(--carina-line-height-body-sm)] text-[var(--carina-text-color-base)]">
          {details.sections.map((section, index) => (
            <div key={`${details.title}-${index}`}>
              {section.heading ? (
                <h3 className="font-[var(--carina-font-weight-semi-bold)] text-[length:var(--carina-font-size-sm)]">
                  {section.heading}
                </h3>
              ) : null}
              {section.description ? <p>{section.description}</p> : null}
              {section.bullets ? (
                <ul className="list-disc pl-5">
                  {section.bullets.map((bullet) => (
                    <li key={bullet}>{bullet}</li>
                  ))}
                </ul>
              ) : null}
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
};

export default FeatureDetailsModal;
